import { useState } from 'react';
import axios from 'axios';
import { CONFIG } from 'variables/config';
import ScopeBuilder from 'components/apiKeyScope/ScopeBuilder';
import type { Industry } from 'services/industryService';

const authHeaders = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

interface ScopeEditorProps {
    apiKeyId: string;
    initialScope: string[];
    industries: Industry[];
    onClose: () => void;
    onSaved: (scope: string[]) => void;
}

export default function ScopeEditor({ apiKeyId, initialScope, industries, onClose, onSaved }: ScopeEditorProps) {
    const [scope, setScope] = useState<string[]>(initialScope);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');

    const handleSave = async () => {
        setBusy(true);
        setError('');
        try {
            const res = await axios.put(`${CONFIG.apiUrl}/admin/api-keys/${apiKeyId}/scope`, { scope }, authHeaders());
            onSaved(res.data.scope);
            onClose();
        } catch (e: any) {
            setError(e?.response?.data?.message || 'Erreur lors de la mise à jour du scope.');
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
            <div className="max-h-[85vh] w-full max-w-2xl overflow-y-auto rounded-xl bg-white p-5 dark:bg-navy-800">
                <p className="mb-1 text-lg font-bold text-navy-700 dark:text-white">Éditer le scope de la clé</p>
                <p className="mb-4 text-sm text-gray-500">
                    Le scope est remplacé intégralement par la sélection ci-dessous.
                </p>

                <ScopeBuilder industries={industries} value={scope} onChange={setScope} />

                {error && <div className="mt-3 rounded-lg bg-red-50 px-3 py-2 text-sm text-red-600">{error}</div>}

                <div className="mt-5 flex justify-end gap-2">
                    <button
                        onClick={onClose}
                        className="rounded-md bg-gray-200 px-4 py-2 text-sm font-medium text-gray-600 hover:bg-gray-300"
                    >
                        Annuler
                    </button>
                    <button
                        onClick={handleSave}
                        disabled={busy}
                        className="rounded-md bg-brand-500 px-4 py-2 text-sm font-medium text-white hover:bg-brand-600 disabled:opacity-50"
                    >
                        {busy ? 'Enregistrement...' : 'Enregistrer'}
                    </button>
                </div>
            </div>
        </div>
    );
}
